import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { Router, NavigationEnd, ActivatedRouteSnapshot } from '@angular/router';
import { MsalService, MsalBroadcastService } from '@azure/msal-angular';
import { EventMessage, EventType, AuthenticationResult, InteractionStatus } from '@azure/msal-browser';
import { filter } from 'rxjs/operators';
import { Title } from '@angular/platform-browser';
import { UsersService } from '../../../services/users.service';
import { NavigationService } from '../../../services/navigation.service';
import { Subject, takeUntil, Subscription } from 'rxjs';
import { GoogleAnaylticsService } from 'src/app/services/google-anayltics.service';
import { PoolingPortalService } from '../../../services/pooling-portal.service';
import { DistributionDataService } from '../../../services/distributionData.service';
import { HttpClient } from '@angular/common/http';
import { UserTrackingService } from 'src/app/services/userTracking.service';
import { environment } from '../../../../environments/environment';
import { StorageService } from 'src/app/services/storage.service';
declare const gtag: Function;

@Component({
  selector: 'app-admin-main',
  templateUrl: './admin-main.component.html',
  styleUrls: ['./admin-main.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class AdminMainComponent implements OnInit {
  public navigationUrl: any = '';
  loginDisplay = false;
  public owners: any = {};
  public invalidUser: boolean = false;
  public displayName: any;
  public iRole: any;
  public partner: any;
  subscription: Subscription;
  fleets: any = [];
  private readonly _destroying$ = new Subject<void>();
  constructor(
    private authService: MsalService,
    private msalBroadcastService: MsalBroadcastService,
    private router: Router,
    private titleService: Title,
    private _storageService: StorageService,
    private _usersService: UsersService,
    private _distributionDataService: DistributionDataService,
    private navService: NavigationService,
    private _poolingPortalService: PoolingPortalService,
    private _googleAnaylticsService: GoogleAnaylticsService,
    private httpClient: HttpClient,
    private _userTrackingService: UserTrackingService
  ) {
    this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        if (this.authService.instance.getAllAccounts().length > 0) {
          this.checkAndSetActiveAccount();
          this.getToken();
        }
        this.parseRoute(this.router.routerState.snapshot.root);
        this.navigationUrl = event.urlAfterRedirects;
      }
      this.router.events.subscribe((evt) => {
        if (!(evt instanceof NavigationEnd)) {
          return;
        }
        window.scrollTo(0, 0)
      });
    })
    this.subscription = this._poolingPortalService.fleet$.subscribe(
      fleet => {
        //if(fleet) this.getOwnerList(fleet);
        if (this.navigationUrl == '/scrubber' && fleet == 'SNAPS') {
          window.location.href = "/";
        }
      }
    )
  }

  ngOnInit(): void {
    this.setLoginDisplay();
    this.msalBroadcastService.msalSubject$
      .pipe(
        filter((msg: EventMessage) => msg.eventType === EventType.LOGIN_SUCCESS || msg.eventType === EventType.ACQUIRE_TOKEN_SUCCESS || msg.eventType === EventType.ACCOUNT_ADDED || msg.eventType === EventType.ACCOUNT_REMOVED),
        takeUntil(this._destroying$)
      )
      .subscribe((result: EventMessage) => {
        if (this.authService.instance.getAllAccounts().length === 0) {
          window.location.pathname = "/";
        } else {
          <AuthenticationResult>result.payload;
        }
      });
    this.msalBroadcastService.inProgress$
      .pipe(
        filter((status: InteractionStatus) => status === InteractionStatus.None),
      )
      .subscribe(() => {
        this.checkAndSetActiveAccount();
      });
  }

  private parseRoute(node: ActivatedRouteSnapshot) {
    this.titleService.setTitle('ST Pooling Portal - ' + node.data['title']);
    if (node.firstChild) {
      this.parseRoute(node.firstChild);
    }
  }

  loadIp() {
    this.httpClient.get(environment.GET_IP_ADDRESS_API).subscribe({
      next: (value: any) => {
        const input = { country: value.country };
        setTimeout(() => {
          this._userTrackingService.updateUserTrackingData(input).subscribe();
        }, 3000);
        
      }
    }
    );
  }

  setLoginDisplay() {
    this.getUserInfo();
  }

  checkAndSetActiveAccount() {
    let activeAccount = this.authService.instance.getActiveAccount();
    if (!activeAccount && this.authService.instance.getAllAccounts().length > 0) {
      let accounts = this.authService.instance.getAllAccounts();
      this.authService.instance.setActiveAccount(accounts[0]);
    }
  }

  /* getOwnerList(fleet) {
    this._distributionDataService.getOwnerList(fleet)
      .subscribe({
        next: (res: any) => {
          this.owners = res.data.getOwnersList.data;
        }
      });
  } */

  getUserInfo() {
    this._usersService.getUsers()
      .subscribe({
        next: (res) => {
          if (res.data.getUserDetails.success) {
            let user = res.data.getUserDetails.user;
            this._storageService.putDataInStorage("userDetails", JSON.stringify(user));
            this._distributionDataService.userLoggedEmail.next(user?.email);
            this.displayName = user.firstName + ' ' + user.lastName;
            this.iRole = user.role;
            this.partner = user.partner;
            if (user.fleet?.length > 0) {
              this.fleets = user.fleet;
            }
            //this.getOwnerList(this.fleets[0]);
            let gaData = {
              eventCategory: "login",
              eventAction: "page load" + ' ' + this.router.url,
              eventLabel: "page_load"
            }
            this.loadIp();
            //check option to remove set timeout while working on GA US - MPP
            setTimeout(() => {
              //let designation = (this.iRole == 1) ? 'Pool Manager' : this._poolingPortalService.getVslOwnerLabel(this.partner, this.owners);
              let role = (this.iRole == 1) ? 'Pool Manager' : 'Pool Partner';
              this._googleAnaylticsService.sendPageTrackingLog(gaData);
              let obj: HTMLScriptElement = document.createElement('script');
              obj.async = true;
              obj.defer = true;
              obj.id = 'data-layer';
              obj.type = 'text/javascript';
              obj.innerHTML = "window.dataLayer = window.dataLayer || [];window.dataLayer.push({ 'event': 'login','UserID': '" + user.userId + "','partner': '" + this.partner + "','role': '" + role + "'})"
              obj.crossOrigin = 'anonymous';
              document.head.prepend(obj);
            }, 10);
          }
        }
      })
  }

  getToken() {
    this.authService.instance.acquireTokenSilent({
      scopes: ["https://graph.microsoft.com/User.Read"],
    }).then((accessToken) => {

    }).catch((error: any) => {
      this.logout();
    });
  }

  logout() {
    this.navService.logout();
  }

  ngOnDestroy(): void {
    this._destroying$.next(undefined);
    this._destroying$.complete();
  }
}
